module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAgCAYAAABts0pHAAABFElEQVRYR+3YWw6CMBAF0DvEHbkO94AuQyEmFHURJuhKHVMjRvigI3TaTCK/0HK4mb4gKFw3xw0D9VTXBXApa9rPfT3NbRhqp41Xg/sP08Srwj3+3rJ7MKrYZaMOl+KJcN5WdAiVYH8/CVwDnwweG58U7vGd4xZAqCROu5omx0VyeCx8FngMfDb4UnxWuBRfENqyosEWgq4Nr6Vzp9ZzqwJHZmwmF6kRnjrHrAWK3e938qbgPogebw7u8QQ4k3CfukX4a1W1Bv9sBcxMhwAG+xcTC9AY/R6gsWdbeX9LdorZEl+Czpa4BB06yiVPPAY6eeKSE38o6f9hWTKHSJL+9Zeceo1roNVr3OQvOE20WuLaaA9/AsCkt2qvg/s4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/icon_01@2x.png
// module id = /NGB
// module chunks = 70